getActiveEvent